import { GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE, GENERAL_PURCHASE_OUTSTANDING_REPORT_REQUEST, GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    generalPurchaseOutstandingReport: {},
    loading: false,
    error: null,
  };
  
  const generalPurchaseOutstandingReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case GENERAL_PURCHASE_OUTSTANDING_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          generalPurchaseOutstandingReport: {},
          error: null
        };
      }
      case GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS: {
        return {
          ...state,
          generalPurchaseOutstandingReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default generalPurchaseOutstandingReportReducer;
  